import { stringifyUrl } from 'query-string'

export type GoToBillingPlanPageOptions = {
  referrerPage?: string
  upgradeURL?: string
  document?: string
  documentType?: string
  coverLetterId?: string
  resumeId?: string
  documentTemplate?: string
  documentFormat?: string
  onSuccessRedirect?: string
  onCloseRedirect?: string
  plan?: string
  fullQueryString?: string
  forceReferrerPage?: string
  tailoring?: boolean
}

export const billingPlanPageURL = (options?: GoToBillingPlanPageOptions) => {
  let referrerPage = options?.referrerPage
  let basicURL = options?.upgradeURL ? options.upgradeURL : '/app/billing/plans'

  const finalURL = stringifyUrl({
    url: basicURL,
    query: {
      referrerPage: options?.forceReferrerPage ? options.forceReferrerPage : referrerPage,
      on_success_redirect: options?.onSuccessRedirect,
      on_close_redirect: options?.onCloseRedirect,
      plan: options?.plan,
      resume_id: options?.resumeId,
      cover_letter_id: options?.coverLetterId,
      document: options?.document,
      document_type: options?.documentType,
      document_format: options?.documentFormat,
      document_template: options?.documentTemplate,
      tailoring: options?.tailoring,
    },
  })

  return finalURL
}

export const goToBillingPlanPage = (options?: GoToBillingPlanPageOptions) => {
  window.location.assign(billingPlanPageURL(options))
}
